import { TCartItem } from '@/entities/cart'

import { ProductType } from '@/shared/types/deprecated-types'

/**
 * Checks in cert list service's and trade-in products
 * @param products - list of products from cart
 */
export const checkNoEntityProducts = (products: TCartItem[]) =>
	products.some(item => item.TYPE_PRODUCTS !== ProductType.Product && item.TYPE_PRODUCTS !== ProductType.Accessory)
